import React, { useEffect, useState } from "react";

let apiUrl = "https://api.openweathermap.org/data/2.5/weather";
let apiKey = "ae5d3d1196478bcc8f53dc5cf483da3a"; // add your API key here
let city ="Philadelphia, USA"; // replace this with your city

function Weather() {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    let api = `${apiUrl}?q=${city}&appid=${apiKey}&units=imperial`;
    fetch(api).then(response => response.json()).then(data => {
      setWeather(data);
    })
  }, []);
  return (
    <div className="weather-2 temperature child-center">
      <div className="weather-align">
        <img width="100px" alt="weather icon" src={weather && "https://openweathermap.org/img/wn/" + weather.weather[0].icon + "@2x.png"}></img>
        <h2>{weather && Math.trunc(weather.main.temp)}°F</h2>
      </div>
      <h3>LOW {weather && Math.trunc(weather.main.temp_min)}° / HIGH {weather && Math.trunc(weather.main.temp_max)}°</h3>
      <h4>{city}</h4>
    </div>
  );
}

export default Weather;